import { Box, useTheme, styled } from "@mui/material"
import { MotionDiv, loadingLogo, loadingScreen } from "../motions"

const Image = styled("img")(() => ({}))

export const LoadingScreen = () => {
  const theme = useTheme()
  const { logo } = theme.assets || {}
  const styleOverrides = theme.components[`LoadingScreen`]?.styleOverrides || {}
  const { root, logo: logoStyle } = styleOverrides
  return (
    <MotionDiv
      key="loading"
      variants={loadingScreen}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <Box sx={root}>
        <MotionDiv key="logo" variants={loadingLogo} animate="animate">
          {logo && <Image src={logo.url} alt="Logo" sx={logoStyle} />}
        </MotionDiv>
      </Box>
    </MotionDiv>
  )
}
